import axios from 'axios';

const JWT =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJhNDE0N2MxNi0zYWFlLTRiOTQtYWIwNy1lNDgwZDY0Y2ZhMGYiLCJlbWFpbCI6IjB4ZWNkOGYyNDJkZTk5Y2IxN2E5YTRlZTFiZWU1MmY2NjEzYzk4Njg2Y0BldGhlcm1haWwuaW8iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJpZCI6IkZSQTEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX0seyJpZCI6Ik5ZQzEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiMTdjNGE2YmUyYTMxOWM4MmUyYjciLCJzY29wZWRLZXlTZWNyZXQiOiJmNDVhMTNlMjcxZTViYWMwNTA4NTUyNDg2ZTM5ZTZiZTU1MTg2ZmI2Nzc1NTg4ODNiZjYxOGE2NGI3ZDU1NGM0IiwiaWF0IjoxNzI0MDY4NDQ3fQ.LL-RVLSx9TPHvRgFX0hkYAzaLmA765d26tduLiviXf0';

export const pinFileToIPFS = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const pinataMetadata = JSON.stringify({
    name: 'File name',
  });
  formData.append('pinataMetadata', pinataMetadata);

  const pinataOptions = JSON.stringify({
    cidVersion: 0,
  });
  formData.append('pinataOptions', pinataOptions);

  try {
    const res = await axios.post(
      'https://api.pinata.cloud/pinning/pinFileToIPFS',
      formData,
      {
        headers: {
          Authorization: `Bearer ${JWT}`,
        },
      },
    );
    console.log(res.data);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
